import React, { useState, useEffect, useCallback } from 'react';
import './ProjectsCarousel.css';

// Import all project images
import Project1 from '../images/Project1.png';
import Project2 from '../images/Project2.png';
import Project3 from '../images/Project3.png';
import Project4 from '../images/Project4.png';
import Project5 from '../images/Project5.png';
import Project6 from '../images/Project6.png';
import Project7 from '../images/Project7.png';
import Project8 from '../images/Project8.png';
import Project9 from '../images/Project9.png';
import Project10 from '../images/Project10.png';
import Project11 from '../images/Project11.png';
import Project12 from '../images/Project12.png';
import Project13 from '../images/Project13.png';
import Project14 from '../images/Project14.png';
import Project15 from '../images/Project15.png';
import Project16 from '../images/Project16.png';
import Project17 from '../images/Project17.png';

const ProjectsCarousel = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);

  const projects = [
    {
      images: [Project1, Project2, Project3, Project4]
    },
    {
      images: [Project5, Project6, Project7, Project8]
    },
    {
      images: [Project9, Project10, Project11, Project12]
    },
    {
      images: [Project13, Project14, Project15, Project16]
    },
    {
      images: [Project17, Project1, Project2, Project3]
    },
    {
      images: [Project4, Project5, Project6, Project7]
    },
    {
      images: [Project8, Project9, Project10, Project11]
    },
    {
      images: [Project12, Project13, Project14, Project15]
    },
    {
      images: [Project16, Project17, Project1, Project2]
    },
    {
      images: [Project3, Project4, Project5, Project6]
    },
    {
      images: [Project7, Project8, Project9, Project10]
    },
    {
      images: [Project11, Project12, Project13, Project14]
    },
    {
      images: [Project15, Project16, Project17, Project1]
    },
    {
      images: [Project2, Project3, Project4, Project5]
    },
    {
      images: [Project6, Project7, Project8, Project9]
    }
  ];

  // Check if mobile/tablet view
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 640);
      setIsTablet(window.innerWidth <= 1024 && window.innerWidth > 640);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  const itemsPerSlide = isMobile ? 1 : isTablet ? 3 : 5;
  const totalSlides = Math.ceil(projects.length / itemsPerSlide);

  const nextSlide = useCallback(() => {
    setCurrentSlide((prev) => (prev + 1) % totalSlides);
  }, [totalSlides]);

  // Auto-play functionality
  useEffect(() => {
    if (!isAutoPlaying) return;

    const interval = setInterval(() => {
      nextSlide();
    }, 5000);

    return () => clearInterval(interval);
  }, [isAutoPlaying, nextSlide]);

  const handleMouseEnter = () => {
    setIsAutoPlaying(false);
  };

  const handleMouseLeave = () => {
    setIsAutoPlaying(true);
  };

  return (
    <div className="projects-carousel-container">
      <div className="projects-wrapper">
        <div className="clients-header">
          <div className="header-content">
            <div className="header-left">
              <h1 className="clients-title">Our <br />
                Projects</h1>
            </div>
            <div className="header-right">
              <p className="clients-subtitle">
                Projects in which integration has made a difference.
              </p>
            </div>
          </div>
          <div className="clients-divider"></div>
        </div>

      <div
        className="carousel-wrapper"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <div className="carousel-track">
          <div
            className="carousel-slide"
            style={{ transform: `translateX(-${currentSlide * 100}%)` }}
          >
            {Array.from({ length: totalSlides }).map((_, slideIndex) => (
              <div key={slideIndex} className="slide-content">
                {projects
                  .slice(slideIndex * itemsPerSlide, (slideIndex + 1) * itemsPerSlide)
                  .map((project, projectIndex) => (
                    <div key={projectIndex} className="project-card">
                      <div className="project-images">
                        {project.images.map((image, imageIndex) => (
                          <div
                            key={imageIndex}
                            className={`project-image ${imageIndex === 0 ? 'active' : ''}`}
                          >
                            <img src={image} alt={`Project ${imageIndex + 1}`} />
                          </div>
                        ))}
                      </div>
                    </div>
                  ))}
              </div>
            ))}
          </div>
        </div>
      </div>
      </div>
    </div>
  );
};

export default ProjectsCarousel;
